/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { routePaths } from '@/constants/routePaths';

const repairGuidesTouchpoints = [routePaths.userMyVehicle, routePaths.vehicleDetails];

export const pageLinksToRepairGuides = (path?: string): boolean =>
  !!path && repairGuidesTouchpoints.some((touchpoint) => path.includes(touchpoint));
